import { safeDefineElement } from '@/scripts/core/global';
import { ShareButton } from '@/scripts/optional/share-button';

safeDefineElement(ShareButton)
